import axios from 'axios'
import qs from 'qs'
import getGlobalParams from './changba-global-params'
import commonObj from 'commonObj'

const symbolJson = 'symbolJson'

// 创建axios实例
const instance = axios.create({
  timeout: 30000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  transformRequest: [
    function(data, headers) {
      if (data instanceof FormData) {
        return data
      }

      if (data?.[symbolJson] === true) {
        headers['Content-Type'] = 'application/json; charset=utf-8'
        delete data.symbolJson
        return JSON.stringify(data)
      }

      return qs.stringify(data)
    }
  ]
})

// request拦截器
instance.interceptors.request.use(
  (config) => {
    if (config.method === 'get') {
      config.params = config.data
    }

    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

function tryParse(info) {
  if (typeof info !== 'string') {
    return info
  }
  let res
  try {
    res = JSON.parse(info)
  } catch (exp) {
    res = info
  }
  if (Object.prototype.toString.call(info) === '[object Object]') {
    return info
  } else {
    return res
  }
}

export default async function(url, inputOptions = {}) {
  const options = { ...inputOptions }

  if (!options.method) {
    options.method = 'get'
  }

  if (!options.data) {
    options.data = {}
  }

  const globalParams = await getGlobalParams()

  // 自动添加 userId, token 参数
  if (!options.data.userid) {
    options.data.userid = tryParse(globalParams.userId)
  }
  if (!options.data.token) {
    options.data.token = tryParse(globalParams.token)
  }

  if (options.upload === true) {
    const fd = new FormData()

    for (const key in options.data) {
      if (Object.prototype.hasOwnProperty.call(options.data, key)) {
        const value = options.data[key]

        if (value === undefined) {
          continue
        }

        if (Array.isArray(value)) {
          value.forEach((item) => {
            fd.append(`${key}[]`, item)
          })
        } else {
          fd.append(key, value)
        }
      }
    }

    options.data = fd
  } else if (options.method === 'post' && options.json === true) {
    options.data[symbolJson] = true
  }

  if (options.method.toLowerCase() === 'get' && options.cache !== true) {
    options.data._ =
      String(+new Date()) + String(Math.floor(Math.random() * 9999))
  }

  if (!options.onUploadProgress && options.onUploadPercent) {
    options.onUploadProgress = (progressEvent) => {
      if (progressEvent.lengthComputable) {
        options.onUploadPercent(
          Math.floor((progressEvent.loaded / progressEvent.total) * 100),
          progressEvent
        )
      }
    }
  }

  const isMock = commonObj.utils.getQueryStrFn('isMock')
  if (process.env.NODE_ENV !== 'production' && isMock) {
    // 唱吧yapi 前端组主站mock地址前缀
    url = 'https://yapi.changbaops.com/mock/32/www' + url
  }
  return instance(url, options)
    .then((response) => {
      let data = response.data

      if (!data) {
        data = {}
      }

      data.$response = response

      return data
    })
    .catch((error) => {
      return {
        code: -99999,
        data: {},
        msg: error.message,
        $response: error
      }
    })
}
